export default "__VITE_ASSET__BujFdj4M__"